const DNAConditionalWrapper = ({ condition, wrapper, children }) => condition ? wrapper(children) : children;
export default DNAConditionalWrapper;
//# sourceMappingURL=DNAConditionalWrapper.js.map